module.exports = __webpack_public_path__ + "static/media/mailing-header.f293d4c1.jpg";